import { type DimensionValue, View } from "react-native"
import React, { type ReactNode, useEffect } from "react"
import Animated, {
  interpolate,
  useAnimatedStyle,
  useSharedValue,
  withTiming,
} from "react-native-reanimated"

export const FlipView = ({
  children,
  back,
  width = "100%",
  height = "100%",
  frontClassname,
  backClassname,
  isFlipped,
}: {
  children: ReactNode
  back: ReactNode
  frontClassname?: string
  backClassname?: string
  width?: DimensionValue
  height?: DimensionValue
  isFlipped: boolean
}) => {
  const spin = useSharedValue<number>(0)

  const rStyle = useAnimatedStyle(() => {
    const spinVal = interpolate(spin.value, [0, 1], [0, 180])
    return {
      transform: [
        { perspective: 1000 },
        {
          rotateY: withTiming(`${spinVal}deg`, { duration: 500 }),
        },
      ],
    }
  }, [])

  const bStyle = useAnimatedStyle(() => {
    const spinVal = interpolate(spin.value, [0, 1], [180, 360])
    return {
      transform: [
        { perspective: 1000 },
        {
          rotateY: withTiming(`${spinVal}deg`, { duration: 500 }),
        },
      ],
    }
  }, [])

  useEffect(() => {
    spin.value = isFlipped ? 1 : 0
  }, [isFlipped])

  return (
    <View style={{ width, height }}>
      <Animated.View
        className={frontClassname}
        style={[{ width, height, position: "absolute" }, rStyle]}
      >
        {children}
      </Animated.View>
      <Animated.View
        className={backClassname}
        style={[
          {
            width,
            height,
            position: "absolute",
            backfaceVisibility: "hidden",
            pointerEvents: isFlipped ? "auto" : "none",
            zIndex: 10,
          },
          bStyle,
        ]}
      >
        {back}
      </Animated.View>
    </View>
  )
}
